/**
 * useOrganizations — the org registry, for the cross-org switcher.
 * Wraps GET /v1/auth/admin/organizations (platform.manage). Only enable it for
 * platform admins; other callers 403.
 */
import { useQuery } from '@tanstack/react-query';

import { config } from '../config';

export interface OrgSummary {
  organizationId: string;
  organizationCode: string;
  name: string;
}

export function useOrganizations(enabled: boolean) {
  return useQuery<OrgSummary[], Error>({
    queryKey: ['admin', 'organizations'],
    enabled,
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const res = await fetch(`${config.API_URL}/v1/auth/admin/organizations`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`Failed to load organizations (${res.status})`);
      const rows = await res.json();
      return rows.map((r: any) => ({
        organizationId: r.organization_id,
        organizationCode: r.organization_code,
        name: r.name,
      }));
    },
  });
}
